import { render, staticRenderFns } from "./InterestRatesView.vue?vue&type=template&id=32f2cce2&scoped=true&"
import script from "./InterestRatesView.vue?vue&type=script&lang=js&"
export * from "./InterestRatesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f2cce2",
  null
  
)

export default component.exports